module.exports = __webpack_public_path__ + "img/shm_logo_SNB.533aaf74.svg";